export const TEST_ID = 'globalStoreProvider';
